module.exports = __webpack_public_path__ + "img/continous_discovery_habbits.2c50dab7.jpg";